import React from "react";
import { InitialState, setArticleDataToStore } from "../../store/ArticleStore";
import { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import useFormatDays from "../../hooks/useFormatDays";

export interface ArticleItemProps {}

function ArticleItem() {
  const { articleData } = useSelector(
    (state: RootState) => state.articleStore as InitialState
  );

  const dispatch = useDispatch();

  return (
    <div className="hero-team-info">
      <div className="team-hero-details">
        <div className="team-hero-address">
          <h1 className="h2">{articleData[0].title}</h1>
          <div className="flex justify-between items-center">
            <span>{useFormatDays(articleData[0].date)}</span>

            {articleData[0].articleslug &&
              articleData[0].articleslug.length && (
                <div>
                  <button
                    onClick={() =>
                      dispatch(setArticleDataToStore([{...articleData[0], isShared: true}]))
                    }
                    className="share-button h-fit gap-2 button bg-slate-400 flex"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-share2-icon lucide-share-2"
                    >
                      <circle cx="18" cy="5" r="3" />
                      <circle cx="6" cy="12" r="3" />
                      <circle cx="18" cy="19" r="3" />
                      <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                      <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                    </svg>
                    Teilen
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>

      {articleData[0].intro && (
        <p
          className="intro"
          dangerouslySetInnerHTML={{ __html: articleData[0].intro }}
        />
      )}
      {articleData[0].description && (
        <p dangerouslySetInnerHTML={{ __html: articleData[0].description }} />
      )}

      <button
        onClick={() => (window.location.href = "/")}
        className="share-button h-fit gap-2 button bg-slate-400 mt-5 flex"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="lucide lucide-chevron-left-icon lucide-chevron-left"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        Zurück zur Startseite
      </button>
    </div>
  );
}

export default ArticleItem;
